import { tv } from "tailwind-variants";

import type { VariantProps } from "~/types/tailwindVariants";

export const invoiceStatusProgressSegmentVariants = tv({
	slots: {
		container:
			"group relative flex flex-1 items-center justify-center overflow-visible whitespace-nowrap border-y py-1 text-sm",
		label: "",
		icon: "ml-1 size-4 shrink-0 stroke-2",
		caretFill: "",
		caretStroke: "",
	},
	variants: {
		theme: {
			upcoming: {
				container: "cursor-pointer border-gray-200 bg-transparent text-xs text-primary-900/50 hover:border-primary-400 hover:bg-primary-400 hover:text-white group-hover:border-primary-400",
				caretFill: "fill-white group-hover:fill-primary-400",
				caretStroke: "stroke-gray-200 stroke-2 group-hover:stroke-primary-400",
			},
			completed: {
				container: "border-transparent bg-gray-200 text-xs text-gray-500 enabled:hover:border-primary-400 enabled:hover:bg-primary-400 enabled:hover:text-white",
				icon: "text-success-700",
				caretFill: "fill-gray-200 group-enabled:group-hover:fill-primary-400",
				caretStroke: "stroke-white stroke-2 group-enabled:group-hover:stroke-primary-400",
			},
			active: {
				container: "border-primary-900 bg-primary-900 font-medium text-white",
				caretFill: "fill-primary-900",
				caretStroke: "stroke-primary-900 stroke-2",
			},
			paid: {
				container: "border-success-700 bg-success-700 font-medium text-white",
				icon: "text-white",
				caretFill: "fill-success-700",
				caretStroke: "stroke-success-700 stroke-2",
			},
			reversed: {
				container: "border-danger-500 bg-danger-500 font-medium text-white",
				caretFill: "fill-danger-500",
				caretStroke: "stroke-danger-500 stroke-2",
			},
			disabled: {
				container: "cursor-not-allowed border-gray-200 bg-transparent text-xs text-primary-900/50",
				caretFill: "fill-white",
				caretStroke: "stroke-gray-200 stroke-2",
			},
			"status-unavailable": {
				container: "cursor-default border-gray-200 bg-transparent text-xs text-primary-900/50",
				caretFill: "fill-white",
				caretStroke: "stroke-gray-200 stroke-2",
			},
		},
		isFirst: {
			true: {
				container: "rounded-l-md border-l",
			},
		},
		isLast: {
			true: {
				container: "rounded-r-md border-r",
			},
		},
	},
	defaultVariants: {
		theme: "upcoming",
		isFirst: false,
		isLast: false,
		clickable: false,
	},
});

export type InvoiceStatusProgressSegmentVariantProps = VariantProps<
	typeof invoiceStatusProgressSegmentVariants
>;